import { useMutation } from "react-query";
import { BASE_ENDPOINT } from "../shared/apiConfig.js";
import axios from "axios";

const axiosApi = axios.create({
  baseURL: BASE_ENDPOINT,
  headers: {
    "Content-Type": "application/json",
  },
});
const usePostQuery = (mutationKey = "", url, config = {}) => {
  return useMutation({
    mutationKey: mutationKey,
    mutationFn: async (formData = {}) => {
      return await axiosApi
        .post(url, formData, config)
        .then((response) => response?.data);
    },
    onSuccess: (res) => {
      return res?.data;
    },
    onError: async (error) => {
      return await error?.response?.data;
    },
  });
};
export { usePostQuery };
